var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3488 1.49897C9.24938 -0.272063 5.99194 -0.437719 2.85938 0.976219V0H1.45312V24H2.85938V15.2469C5.74542 13.7331 8.77622 13.7802 11.6512 15.4229C13.3754 16.4083 15.1483 16.9005 16.9219 16.9005C18.6948 16.9005 20.4684 16.4082 22.1925 15.4229L22.5469 15.2204V0.897469L21.495 1.49897C18.5039 3.20869 15.3412 3.20869 12.3488 1.49897Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.768b5fee7bb796078170bfab62d6f18a.svg";
export { ForwardRef as ReactComponent };